module.exports = __webpack_public_path__ + "2a85035adf197ca1c9fd6743a4a5a68c.svg";